import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { CommercialClientTermResponse } from '@interfaces/partners/responses/commercial-client-term.response';
import { SharedModule } from '@src/app/shared/shared.module';
import { consentNotice } from '@src/app/features/dashboard/commercial/pages/deal-detail/deal-consent-notice';

/**
 * Card **Consentimento SCR** do deal (card 3418), na coluna lateral da Visão geral e da aba KYC.
 *
 * O estado vem de `consentNotice` (`deal-consent-notice.ts`): faixa verde quando o termo fechou,
 * âmbar quando aguarda a assinatura do cliente ou ainda não foi enviado. Sem termo, ou cancelado,
 * o card não tem o que mostrar e não desenha nada. Abaixo da faixa: validade, versão, assinantes
 * do cliente (o lado Legatus não é consentimento do cliente) e "Ver documento", sempre que há termo
 * (igual ao "Ver termo" da etapa Consentimento).
 */
@Component({
  selector: 'app-deal-consent-card',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './deal-consent-card.component.html',
  styleUrl: './deal-consent-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DealConsentCardComponent {
  /** Termo do cliente do deal. */
  readonly term = input<CommercialClientTermResponse | null>(null);

  /** O documento do termo está sendo aberto (o botão mostra o carregamento). */
  readonly openingTerm = input(false);

  /** Pede ao pai para abrir o PDF do termo no visualizador. */
  readonly openTerm = output<void>();

  protected readonly notice = computed(() => consentNotice(this.term()));

  /** Assinantes do lado do cliente, na ordem do termo. */
  protected readonly clientSignatories = computed(() =>
    (this.term()?.signatories ?? []).filter(s => s.side === 'Cliente')
  );
}
